import routerOptions0 from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/node_modules/.pnpm/nuxt@3.11.2_eslint@8.40.0_rollup@4.27.3_sass@1.62.1_terser@5.36.0_typescript@5.0.4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}